/**
 * Environment detection, driven by the Firebase projectId — the same value
 * that decides which backend the app talks to, so the indicator can never
 * drift from the environment (unlike NODE_ENV / import.meta.env.MODE or a
 * separate env var, which could disagree with the Firebase config).
 */

/** The Firebase project that serves production (app.gamutapp.ai). */
export const PROD_PROJECT_ID = 'gamut-prod';

/** Prefix applied to `document.title` in dev so browser tabs are distinct. */
export const DEV_TITLE_PREFIX = '[DEV] ';

/**
 * True for anything that is not the prod project — an unknown or missing
 * projectId must read as dev, never as prod.
 */
export function isDevProject(projectId: string | undefined): boolean {
  return projectId !== PROD_PROJECT_ID;
}
